import { CommonModule } from '@angular/common';
import { Component, ComponentRef, DebugElement, ElementRef, Renderer2, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Feature, Map, Overlay, View } from 'ol';
import { ScaleLine } from 'ol/control.js';
import { fromLonLat, ProjectionLike, transform } from 'ol/proj';
import { Subject, Subscription, catchError, forkJoin, map, of, switchMap, takeUntil } from 'rxjs';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Icon from 'ol/style/Icon';
import { Point } from 'ol/geom';
import { Fill, Stroke, Style, Text } from 'ol/style';
import { CurrentStateService } from '../../../../core/services/current-state.service';
import { ControlPoint } from '../../../../shared/models/controlPoint';
import { Site } from '../../../../shared/models/site';
import { Coordinate } from 'ol/coordinate';
import { MapLayersControler } from './../../helpers/mapLayers';
import { CarteControllersGadgetComponent } from './../../widgets/carte-controllers-gadget/carte-controllers-gadget.component';
//import proj4 from 'proj4';
//import { register } from 'ol/proj/proj4';
import CircleStyle from 'ol/style/Circle';
import { MENU_OPTIONS } from '../../../../shared/constants/left-menu-option';
import { FonctionsService } from '../../../../shared/services/utilities/fonctions.service';
import { ControlPointModaleComponent } from '../../../control-points/components/control-point-modale/control-point-modale.component';
import { SlideMenuControlPointsComponent } from '../../../control-points/components/slide-menu-control-points/slide-menu-control-points.component';
import { PopupOpenMode, PopupCloseMode } from '../../../control-points/models/popupMode';
import { ControlPointsService } from '../../../control-points/services/control-points-service';
import { SlideMenuComponent } from '../../../slide-menu/slide-menu.component';
import { EventModalComponent } from '../../../vibration-events/components/event-modal/event-modal.component';
import { EventData } from '../../../vibration-events/models/event-data';
import { EventService } from '../../../vibration-events/services/event-service';
import MapConstants from '../../models/map-constants';
import { MapHttpService } from '../../services/map-service';
import { PositionGadgetComponent } from '../../widgets/position-gadget/position-gadget.component';
import { FEATURE_TYPE, MAP_VIEW_TYPE } from '../../models/map-enums';
import { MapSubscriptionService } from '../../services/map-subscription.service';
import { MapUtilsService } from '../../services/map-utils.service';
import { ApiResponse } from '../../../../shared/models/api-response';
import { ProjectionService } from '../../services/projection-service';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import { ActivatedRoute } from '@angular/router';
import { CustomCoordinate } from '../../../../shared/models/customCoordinate';
import html2canvas from 'html2canvas';
import { LocalStorageService } from '@shared/services/utilities/local-storage.service';
import { PositionService } from '@shared/services/utilities/position.service';
import { VibrationsRecordService } from '@shared/services/records/vibrations-record.service';
import { VibrationsChart } from '@shared/models/charts/VibrationsChart';
import { defaults as defaultControls } from 'ol/control.js';
import { MonitoringService } from '@features/monitoring/services/monitoring.service';
import { DevicesDto } from '@shared/models/devices-dto';
import { TranslateModule } from '@ngx-translate/core';

const MAP_VIEW_RECORDS_STORAGE_KEY = 'mapViewRecords';
const MAP_SATELLITE_STORAGE_KEY = 'mapSatelliteVisible';


@Component({
  selector: 'app-map',
  imports: [
    CommonModule,
    FormsModule,
    PositionGadgetComponent,
    CarteControllersGadgetComponent,
    SlideMenuComponent,
    TranslateModule
  ],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss'
})
export class MapComponent {
  @ViewChild('popupContainer', { read: ViewContainerRef })
  popupContainer: ViewContainerRef;
  private _popupCreateRef: ComponentRef<any> | null = null;
  protected map!: Map;
  public vectorSourceBasePoint: VectorSource = new VectorSource();
  public vectorSourceBaseEvent: VectorSource = new VectorSource();
  public vectorSourceBaseRecord: VectorSource = new VectorSource();
  protected vectorLayerBasePoint!: VectorLayer<any>;
  protected vectorLayerBaseEvent!: VectorLayer<any>;
  protected vectorLayerBaseRecord!: VectorLayer<any>;
  protected vectorSourceCreatePoint!: VectorSource;
  protected vectorLayerCreatePoint!: VectorLayer<any>;
  protected popupOverlay!: Overlay;
  protected hoveredFeature: any = null;
  protected view = new View({
    projection: MapConstants.EPSG_REFERENCE_OL,
    center: [0, 0],
    zoom: 5,
  });
  public selectedSite?: Site;
  public selectedControlPoint?: ControlPoint;
  public selectedEvent?: EventData;
  protected listeSites_filtred: Site[] = [];
  protected listeSites: Site[] = [];
  protected toggleSelect: boolean = false;
  protected searchValue: string = '';
  public controlPoints: ControlPoint[] = [];
  vibrationRecords: VibrationsChart[];
  private alarmControlPointIds: number[] = [];
  protected allEvents: EventData[] = [];
  // Object to store all event features (both visible and hidden)
  private allEventFeatures: { [eventId: number]: Feature } = {};
  private minZoomToShowPoints = 12;
  private unsubscribe$ = new Subject<void>();
  private menuSubscription$ = new Subject<void>();
  protected showContextMenu: boolean = false;
  protected menuPosition = { x: 0, y: 0 };
  protected pointClickedPosition: Coordinate | undefined;
  protected mousePosition: CustomCoordinate | undefined;
  protected isDegre: boolean = false;
  public mapLayersControler!: MapLayersControler;
  private popupControlPointOpenMode: PopupOpenMode | null = null;
  private createPointLock: boolean = false;
  private createPointFeature!: Feature | null;
  protected showFilterPanel = false;
  protected showVibrationRecords = true;
  protected selectedMapLayerButton: number = -1;

  public selectedControlPointFeature!: Feature | null;
  public selectedEventFeature!: Feature | null;

  public iconControlPoint!: Icon;
  public iconControlPointAlarm!: Icon;
  public iconBlast!: Icon;
  public iconRecord!: Icon;
  public iconControlPointPosition!: Icon;
  public iconSourcePosition!: Icon;

  eventId?: number;
  controlPointId?: number;
  siteId?: number;

  overlay!: Overlay;

  constructor(
    public currentStateService: CurrentStateService,
    private controlPointsHttpService: ControlPointsService,
    private mapHttpService: MapHttpService,
    public fonctionsService: FonctionsService,
    private renderer: Renderer2,
    private el: ElementRef,
    private eventService: EventService,
    private mapSubscriptionService: MapSubscriptionService,
    private mapUtilsService: MapUtilsService,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private positionService: PositionService,
    private vibrationsRecordService: VibrationsRecordService,
    private monitoringService: MonitoringService
  ) {
    this.currentStateService.currentSite$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (site: Site | null) => {
          this.currentStateService.setClosePopup(PopupCloseMode.CLOSE);
          this.selectedControlPointFeature?.setStyle(undefined);
          if (site) {
            this.localStorageService.setItem('currentSiteID', site.siteId);
            this.selectedSite = site;
            this.InitMapData(site.siteId!);
            if (this.mapLayersControler) {
              this.registerProjString()
                .then(() => {
                  this.mapLayersControler.changeSite(site);
                  this.panTo([this.selectedSite!.coordX, this.selectedSite!.coordY]);
                  this.setMouseCoordinates();

                  this.registerProjString()
                    .then(() => {
                      this.panTo([this.selectedSite!.coordX, this.selectedSite!.coordY]);
                      this.setMouseCoordinates();
                    })
                })
                .catch(error => {
                  console.error('Error registering projection:', error);
                  this.fonctionsService.launch_toast(false, 'We dont have coordinates for this site.');
                  this.panTo(MapConstants.DEFAULT_CORDINATES);
                });
            }
          }
        },
      });
    this.mapSubscriptionService.subscribeToCurrentEvent(this, this.controlPoints);
    this.mapSubscriptionService.subscribeToCurrentControlPoint(this);
    this.mapSubscriptionService.subscribeToOpenPopup(this);
    this.mapSubscriptionService.subscribeToNewControlPointCreated(this);
    this.mapSubscriptionService.subscribeToNewEventCreated(this);
    
    // Subscribe to event visibility updates
    this.currentStateService.eventVisibilityUpdate$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (update) => {
          if (update) {
            this.updateEventVisibilityOnMap(update.eventId, update.isHidden);
          }
        }
      });
  }


  ngOnInit(): void {
    this.selectedSite = this.currentStateService.getCurrentSite()!;
    this.showVibrationRecords = this.getStoredViewRecordsState();
    this.initMap();
    this.setImage();
    this.mapLayersControler = new MapLayersControler(this.map!, this.mapHttpService, this.selectedSite!);
    this.applyStoredMapLayerPreference();
    this.route.queryParams.subscribe(params => {
      this.eventId = +params['eventId'];
      this.controlPointId = +params['controlPointId'];
      this.siteId = +params['siteId'];

      if (this.siteId) {
        this.InitMapData(this.siteId);
      }

      this.currentStateService.setCurrentSite(this.selectedSite);
    });
  }

  setImage() {
    this.map.on('click', (event) => {
      this.zoomToPoint();
    })
  }

  private formatLocalDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.mapSubscriptionService.unsubscribe();
  }
  captureMapImage(width: number, height: number) {
    if (!this.map) return;
    html2canvas(this.map.getViewport()).then(canvas => {
      const croppedCanvas = document.createElement('canvas');
      croppedCanvas.width = width;
      croppedCanvas.height = height;

      const ctx = croppedCanvas.getContext('2d');
      if (!ctx) return;

      const mapWidth = canvas.width;
      const mapHeight = canvas.height;
      const startX = (mapWidth - width) / 2;
      const startY = (mapHeight - height) / 2;

      ctx.drawImage(canvas, startX, startY, width, height, 0, 0, width, height);
      const imgData = croppedCanvas.toDataURL('image/png');
      this.localStorageService.setItem('map-image-url', imgData);
    });
  }

  zoomToPoint() {
    if (!this.map) return;
    // setTimeout(() => {
    //   this.captureMapImage(500,500);
    // }, 500); 
  }

  loadEvents(siteId: number,  controlPointId: number) {
      if(siteId == null || siteId === 0) {
        this.mapUtilsService.createEventsFeatures(this.iconBlast, this.vectorSourceBaseEvent, []);      
        return;
      }
    this.eventService.getVibrationEvents(siteId, controlPointId).subscribe({
      next: (events: ApiResponse<EventData[]>) => {
        this.allEvents = [...events.data];
        
        this.currentStateService.setCurrentEvents(this.allEvents);
        // Create features for all events, but only add visible ones to the map
        this.createAllEventFeatures(events.data);
        this.LoadVibrationRecords(siteId, null ,this.allEvents.map(event => event.id));
      },
      error: er => {
        console.error('Error init  vibration events:', er);
      },
    });
  }

  /**
   * Create features for all events but only add visible ones to the map
   * Store all features in allEventFeatures for later visibility management
   */
  private createAllEventFeatures(events: EventData[]) {
    // Clear existing features
    this.vectorSourceBaseEvent.clear();
    this.allEventFeatures = {};
    
    events.forEach((event: EventData) => {
      if (event.positionCoordinates) {
        const coord = transform([event.positionCoordinates.x, event.positionCoordinates.y], MapConstants.EPSG_WGS84, MapConstants.EPSG_REFERENCE_OL);
        const feature = new Feature(new Point(coord));
        feature.set(MapConstants.FEATURE_NAME, FEATURE_TYPE.event);
        feature.set(MapConstants.FEATURE_LABEL, event.name);
        feature.set(MapConstants.FEATURE_ID, event.id);
        const featureStyle = this.mapUtilsService.createStyle(this.iconBlast, event.name);
        feature.setStyle(featureStyle);
        
        // Store the feature
        this.allEventFeatures[event.id] = feature;
        
        // Only add to map if the event is visible
        if (!event.isHidden) {
          this.vectorSourceBaseEvent.addFeature(feature);
        }
      }
    });
  }

  LoadControlPoints(siteId: number, eventId: number) {
    if(siteId === 0 && eventId === 0) {
      this.mapUtilsService.createPointsFeatures(this.iconControlPoint, this.vectorSourceBasePoint, []);
      return;
    }    
    this.controlPointsHttpService.getControlPointsBySiteId(siteId, false).subscribe({
      next: (points: ControlPoint[]) => {
        if(eventId > 0) {
        this.eventService.getControlPointsByEventId(this.selectedSite!.siteId, eventId).subscribe( controlPointIds => {
          this.controlPoints = [...points.filter(cp => controlPointIds.data.includes(cp.controlPointId))];
            this.mapUtilsService.createPointsFeatures(this.iconControlPoint, this.vectorSourceBasePoint, this.controlPoints);
            this.refreshControlPointAlarmsByEquipment(siteId, this.controlPoints.map(cp => cp.controlPointId));
          })
          }
          else{
            this.controlPoints = [...points];
            this.mapUtilsService.createPointsFeatures(this.iconControlPoint, this.vectorSourceBasePoint, points);
            this.refreshControlPointAlarmsByEquipment(siteId, points.map(cp => cp.controlPointId));
          }
          this.LoadVibrationRecords(siteId, this.controlPoints.map(cp => cp.controlPointId), null);
      },
      error: er => {
      },
    });
  }
  LoadVibrationRecords(siteId: number, controlPointIds?: number[], eventIds?: number[]) {
    if (!this.showVibrationRecords) {
      this.vibrationRecords = [];
      this.vectorSourceBaseRecord.clear();
      return;
    }

    this.vibrationsRecordService.GetRecords(siteId, null,null, null, null, null, null, false,false,false, controlPointIds,eventIds, null, null, true)
    .subscribe({
      next: (response) => {
        this.vibrationRecords = response.data != undefined ? response.data.records : [];
        this.mapUtilsService.createRecordsFeatures(this.iconRecord, this.vectorSourceBaseRecord, this.vibrationRecords.map(record => record.recordMetadata));
      },
      error: (err) => {
      }
    });
  }

  protected toggleFilterPanel(): void {
    this.showFilterPanel = !this.showFilterPanel;
  }

  protected onViewRecordsToggle(): void {
    this.localStorageService.setItem(MAP_VIEW_RECORDS_STORAGE_KEY, this.showVibrationRecords);
    this.vectorLayerBaseRecord?.setVisible(this.showVibrationRecords);

    if (!this.showVibrationRecords) {
      this.vectorSourceBaseRecord.clear();
      return;
    }

    if (!this.selectedSite?.siteId) {
      return;
    }

    const currentMenu = this.currentStateService.getCurrentMenu?.() ?? null;
    if (currentMenu === MENU_OPTIONS.EVENT) {
      this.LoadVibrationRecords(this.selectedSite.siteId, null, this.allEvents.map(event => event.id));
      return;
    }

    this.LoadVibrationRecords(this.selectedSite.siteId, this.controlPoints.map(cp => cp.controlPointId), null);
  }

  private getStoredViewRecordsState(): boolean {
    if (!this.localStorageService.hasItem(MAP_VIEW_RECORDS_STORAGE_KEY)) {
      return true;
    }

    return this.localStorageService.getItem<boolean>(MAP_VIEW_RECORDS_STORAGE_KEY) ?? true;
  }

  public refreshControlPointAlarmsByEquipment(siteId: number, controlPointIds: number[]): void {
    if (!siteId || !controlPointIds?.length) {
      this.alarmControlPointIds = [];
      this.mapUtilsService.updateControlPointAlarmState(
        this.vectorSourceBasePoint,
        this.alarmControlPointIds,
        this.iconControlPoint,
        this.iconControlPointAlarm,
        this.selectedControlPoint?.controlPointId ?? null
      );
      return;
    }

    const searchCriteria: any = {
      siteId,
      pageNumber: 1,
      pageSize: 10000,
      controlPointIds
    };

    const endDate = new Date();
    const startDate = new Date(endDate.getTime() - 4 * 24 * 60 * 60 * 1000);

    this.monitoringService.getMonitoringDevices(searchCriteria)
      .pipe(
        switchMap((response) => {
          const devices: DevicesDto[] = response?.data ?? [];
          if (!devices.length) {
            return of([] as DevicesDto[]);
          }

          const detailsRequests = devices
            .filter(device => !!device?.deviceName)
            .map((device) =>
              this.monitoringService.getMonitoringDevice({
                serialNumber: device.deviceName,
                startDate: this.formatLocalDateTime(startDate),
                endDate: this.formatLocalDateTime(endDate),
              } as any).pipe(
                map((detailsResponse) => {
                  const detailedDevice: DevicesDto | undefined = detailsResponse?.data;
                  if (!detailedDevice) {
                    return device;
                  }

                  return {
                    ...detailedDevice,
                    controlPointId: detailedDevice.controlPointId ?? device.controlPointId,
                    deviceName: detailedDevice.deviceName ?? device.deviceName,
                    redAlertValue: detailedDevice.redAlertValue ?? device.redAlertValue,
                    orangeAlertValue: detailedDevice.orangeAlertValue ?? device.orangeAlertValue,
                    yellowAlertValue: detailedDevice.yellowAlertValue ?? device.yellowAlertValue,
                  } as DevicesDto;
                }),
                catchError(() => of(device))
              )
            );

          if (!detailsRequests.length) {
            return of(devices);
          }

          return forkJoin(detailsRequests);
        })
      )
      .subscribe({
        next: (devices) => {
          this.alarmControlPointIds = this.getAlarmedControlPointIdsFromDevices(devices);
          this.mapUtilsService.updateControlPointAlarmState(
            this.vectorSourceBasePoint,
            this.alarmControlPointIds,
            this.iconControlPoint,
            this.iconControlPointAlarm,
            this.selectedControlPoint?.controlPointId ?? null
          );
        },
        error: () => {
          this.alarmControlPointIds = [];
          this.mapUtilsService.updateControlPointAlarmState(
            this.vectorSourceBasePoint,
            this.alarmControlPointIds,
            this.iconControlPoint,
            this.iconControlPointAlarm,
            this.selectedControlPoint?.controlPointId ?? null
          );
        }
      });
  }

  private getAlarmedControlPointIdsFromDevices(devices: DevicesDto[]): number[] {
    const controlPointIds = new Set<number>();

    devices.forEach((device) => {
      if (!device?.controlPointId || !this.hasEquipmentAlarm(device)) {
        return;
      }
      controlPointIds.add(device.controlPointId);
    });

    return Array.from(controlPointIds);
  }

  private hasEquipmentAlarm(device: DevicesDto): boolean {
    if (!device?.monitorings?.length) {
      return false;
    }

    const thresholds = [device.redAlertValue, device.orangeAlertValue, device.yellowAlertValue]
      .filter((threshold) => threshold != null);

    if (!thresholds.length) {
      return false;
    }

    return device.monitorings.some((monitoring) =>
      thresholds.some((threshold) => monitoring.vectorSum > threshold)
    );
  }
  public InitMapData(siteId: number) {
    this.menuSubscription$.next();
    this.currentStateService.currentMenu$.pipe(takeUntil(this.menuSubscription$), takeUntil(this.unsubscribe$)).subscribe(x => {
      if (x === null || x === MENU_OPTIONS.CONTROL_POINT) {
        this.LoadControlPoints(siteId, 0);
        this.loadEvents(0, 0);
      }
      else if (x === MENU_OPTIONS.EVENT) {
        this.loadEvents(siteId, 0);
        this.LoadControlPoints(0, 0);
      }
    })
  }

  private createFullEpsgName(): ProjectionLike {
    let epsg: ProjectionLike;
    this.isDegre = true;
    if (null !== this.selectedSite!.epsg && undefined !== this.selectedSite!.epsg) {
      epsg = 'EPSG:' + this.selectedSite!.epsg;
      if (undefined !== this.selectedSite!.epsg && '4326' !== this.selectedSite!.epsg) {
        this.isDegre = false;
      }
    } else {
      epsg = 'EPSG:4326';
      this.isDegre = true;
    }
    return epsg;
  }

  

  private initMap() {
    this.vectorSourceBasePoint = new VectorSource();
    this.vectorSourceBaseEvent = new VectorSource();
    this.vectorSourceCreatePoint = new VectorSource();
    this.vectorSourceBaseRecord = new VectorSource();
    this.iconControlPoint = new Icon({
      src: './icon/controlPoint.svg',
      scale: 1 ,
    });

    this.iconControlPointAlarm = new Icon({
      src: './icon/control_point_alarm_badge.svg',
      scale: 0.7,
    });

    this.iconBlast = new Icon({
      src: './icon/source.svg',
      scale: 1,
    });

    this.iconRecord = new Icon({
      src: './icon/record.svg',
      scale: 0.75,
    });

    this.iconControlPointPosition = new Icon({
      src: './icon/control-point-position.svg',
      scale: 0.7,
    });
    this.iconSourcePosition = new Icon({
      src: './icon/source-position.svg',
      scale: 0.7,
    });
    this.vectorLayerBasePoint = new VectorLayer({
      source: this.vectorSourceBasePoint,
      zIndex: 3,
      style: new Style({
        image: this.iconControlPoint,
      }),
    });

    this.vectorLayerBaseEvent = new VectorLayer({
      source: this.vectorSourceBaseEvent,
      zIndex: 3,
      style: new Style({
        image: this.iconBlast,
      }),
    });

    this.vectorLayerBaseRecord = new VectorLayer({
      source: this.vectorSourceBaseRecord,
      zIndex: 3,
      visible: this.showVibrationRecords,
      style: new Style({
        image: this.iconRecord,
      }),
    });

    this.vectorLayerCreatePoint = new VectorLayer({
      source: this.vectorSourceCreatePoint,
      zIndex: 3,
      style: new Style({
        image: this.iconControlPointPosition,
      }),
    });

    // Définition de l'overlay
    this.overlay = new Overlay({
      element: document.getElementById('popup')!,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });

    // Initialisation de la carte
    this.map = new Map({
      layers: [this.vectorLayerBasePoint, this.vectorLayerCreatePoint],
      controls: defaultControls({
        zoom: false,
        attribution: false,
      }),
      target: 'map',
      view: this.view,
      overlays: [this.overlay],
    });
    
    // Ajout de la couche d'événements
    this.map.addLayer(this.vectorLayerBaseEvent);
    this.map.addLayer(this.vectorLayerBaseRecord);

    // Configuration des interactions
    this.setupZoomListener();
    this.onHover();
    this.onClick();
    this.onSingleClick();
    this.map.getView().on('change:resolution', () => this.updateCustomScale());
    this.updateCustomScale(); // init
  }
  private updateCustomScale() {
  const view = this.map.getView();
  const resolution = view.getResolution();
  const dpi = 25.4 / 0.28; 
  const metersPerUnit = view.getProjection().getMetersPerUnit();


  const nominalCount = resolution * dpi * metersPerUnit;
  const niceScale = this.getNiceScale(nominalCount);

  const scaleWidth = niceScale / metersPerUnit / resolution;

  const scaleText = document.getElementById('scale-text');
  const scaleBar = document.getElementById('scale-bar');

  if (scaleText && scaleBar) {
    scaleText.innerText = this.formatScaleLabel(niceScale);
    scaleBar.style.width = `${scaleWidth}px`;  }
}
private getNiceScale(rawLength: number): number {
  const scales = [1, 2, 5];
  const exponent = Math.floor(Math.log10(rawLength));
  const base = Math.pow(10, exponent);
  const factor = rawLength / base;

  let nice = scales.find(s => s >= factor);
  if (!nice) nice = 10;

  return nice * base;
}
private formatScaleLabel(length: number): string {
  return length >= 1000 ? `${length / 1000} km` : `${length} m`;
}

  /**
   * Pans the map to the specified coordinate (in WGS84) with animation.
   */
  // epsg map: EPSG:3857
  // epsg of all cordinates in the database Explore: EPSG:4326 !
  public panTo(val: any, duration: number = 50, zoom: number = 15) {
    const panToCoords = transform(val, MapConstants.EPSG_WGS84, MapConstants.EPSG_REFERENCE_OL);
    if (null != this.selectedSite!.epsg) {
      this.view.animate({
        center: panToCoords,
        duration: duration,
        zoom: zoom,
      });
    } else {
      //center in France if no coordinate ;)
      this.view.animate({
        zoom: zoom,
        center: fromLonLat(MapConstants.DEFAULT_CORDINATES),
        duration: duration,
      });
    }
  }

  public layerSwitch(button: number) {
    if (button === 1) {
      this.mapLayersControler!.toggleLayer(MAP_VIEW_TYPE.geoserver, !this.mapLayersControler!.isOrthoLayerVisible);
    } else if (button === 2) {
      this.mapLayersControler!.toggleLayer(MAP_VIEW_TYPE.ol, !this.mapLayersControler!.isOSMLayerVisible);
    } else if (button === 3) {
      const visible = !this.mapLayersControler!.isMapboxLayerVisible;
      this.mapLayersControler!.toggleLayer(MAP_VIEW_TYPE.mapbox, visible);
      this.localStorageService.setItem(MAP_SATELLITE_STORAGE_KEY, visible);
      this.selectedMapLayerButton = visible ? 1 : -1;
    }
  }

  private applyStoredMapLayerPreference(): void {
    const satelliteVisible = this.localStorageService.getItem<boolean>(MAP_SATELLITE_STORAGE_KEY) ?? false;
    this.selectedMapLayerButton = satelliteVisible ? 1 : -1;

    if (satelliteVisible) {
      this.mapLayersControler!.toggleLayer(MAP_VIEW_TYPE.mapbox, true);
    }
  }

  private setupZoomListener() {
    this.map!.getView().on('change:resolution', () => {
      const zoom = this.map!.getView().getZoom();

      if (zoom && zoom < this.minZoomToShowPoints) {
        this.vectorLayerBasePoint!.setVisible(false); // Hide points when zoom is too far out
      } else {
        this.vectorLayerBasePoint.setVisible(true); // Show points when zoomed in
      }
    });
  }

  public registerProjString(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.mapHttpService
        .getProj(this.selectedSite!)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (projString: string) => {
            if (projString) {
              proj4.defs('EPSG:' + this.selectedSite!.epsg, projString);
              register(proj4);
              resolve(); // Resolve the promise after registration
            } else {
              reject(new Error('Invalid projection string')); // Reject if no valid projection string is provided
            }
          },
          error: err => {
            reject(err); // Reject if there's an error in the HTTP request
          },
        });
    });
  }

  onHover() {
    this.map!.on('pointermove', evt => {
      const pixel = this.map!.getEventPixel(evt.originalEvent);
      const hit = this.map!.hasFeatureAtPixel(pixel);
      this.map!.getTargetElement().style.cursor = hit ? 'pointer' : '';
    });
  }

  onClick() {
    this.map!.on('click', evt => {
      let features = this.map!.getFeaturesAtPixel(evt.pixel);

      if (features.length === 0 && this.popupControlPointOpenMode === null) {
                      this.iconBlast = new Icon({
              src: './icon/source_red.svg',
              scale: 1,
            });
        this.currentStateService.toggleSlideMenu(null, null, true);
        this.mapUtilsService.applyStyleToFeature(this.iconControlPoint, this.vectorSourceBasePoint, -1, this.iconControlPointAlarm);
        this.mapUtilsService.applyStyleToFeature(this.iconBlast, this.vectorSourceBaseEvent, -1);

        return;
      }

      let pointFeature = features.find(f => f.get(MapConstants.FEATURE_NAME) == FEATURE_TYPE.controlPoint);
      let eventFeature = features.find(f => f.get(MapConstants.FEATURE_NAME) == FEATURE_TYPE.event);

      if (!pointFeature && !eventFeature) {
        return;
      }

      if (pointFeature) {
        const controlPointId = pointFeature.get(MapConstants.FEATURE_ID);
        this.selectedControlPoint = this.controlPointsHttpService.getControlPointById(this.selectedSite?.siteId!, controlPointId);
        if (this.selectedControlPoint) {
          this.currentStateService.setCurrentControlPoint(this.selectedControlPoint);
          // this.currentStateService.setCurrentMenu(MENU_OPTIONS.CONTROL_POINT);
          this.currentStateService.toggleSlideMenu(null, MENU_OPTIONS.CONTROL_POINT, true);
          this.localStorageService.setItem('currentMenu', MENU_OPTIONS.CONTROL_POINT);
          setTimeout(() => {
          this.mapUtilsService.applyStyleToFeature(this.iconControlPoint, this.vectorSourceBasePoint, controlPointId, this.iconControlPointAlarm);
          }, 600);
          
          this.loadEvents(this.selectedSite!.siteId!, this.currentStateService.getCurrentControlPoint().controlPointId);
        }

      } else if (eventFeature) {
        const eventId = eventFeature.get(MapConstants.FEATURE_ID);
        this.selectedEvent = this.allEvents.find(e => e.id === eventId);
        if (this.selectedEvent) {
          this.currentStateService.setCurrentEvent(this.selectedEvent);
          this.currentStateService.setCurrentMenu(MENU_OPTIONS.EVENT);
          this.currentStateService.toggleSlideMenu(true, MENU_OPTIONS.EVENT, true);
          this.localStorageService.setItem('currentMenu', MENU_OPTIONS.EVENT);
          setTimeout(() => {
          this.mapUtilsService.applyStyleToFeature(this.iconBlast, this.vectorSourceBaseEvent, eventId);
        }, 600);        
        this.LoadControlPoints(this.selectedSite!.siteId!, eventId);
        }
      }
    });
  }

  onSingleClick() {

    // Add click event listener
    this.map.on('singleclick', event => {

      // Example: Add points to different sources based on a condition

      if (this._popupCreateRef && !this.createPointLock) {
        // Remove the previous feature if it exists
        if (this.createPointFeature) {
          this.vectorSourceCreatePoint.removeFeature(this.createPointFeature);
        }

        const pixelCoords = this.map.getPixelFromCoordinate(event.coordinate);
        //adjust for cursor 'target icon'
        const offsetX = 12; // Offset in pixels to the right
        const offsetY = 0; // Offset in pixels upward (negative value moves up)

        const adjustedPixel = [pixelCoords[0] + offsetX, pixelCoords[1] + offsetY];
        const adjustedCoordinate = this.map.getCoordinateFromPixel(adjustedPixel);

        this.createPointFeature = new Feature({
          geometry: new Point(adjustedCoordinate as [number, number]),
        });

        this.vectorSourceCreatePoint.addFeature(this.createPointFeature);

        const coordsCustome: CustomCoordinate = {
          coordX: adjustedCoordinate[0],
          coordY: adjustedCoordinate[1],
          coordZ: undefined
        };

        if (this._popupCreateRef) {
          this._popupCreateRef.instance.setPositionEPSG_REFERENCE_OL(coordsCustome);
          
          let epsg: ProjectionLike = this.createFullEpsgName();

          let coordtrans = transform(event.coordinate, MapConstants.EPSG_REFERENCE_OL, epsg);

          let customCoordinate = {
            coordX: this.isDegre ? coordtrans[0].toFixed(4) : coordtrans[0].toFixed(0),
            coordY: this.isDegre ? coordtrans[1].toFixed(4) : coordtrans[1].toFixed(0),
          } as CustomCoordinate;

          this._popupCreateRef.instance.setPositionEpsgSite(customCoordinate);
        }
      }
    });
  }

  private isLonLat(coords: [number, number]): boolean {
    const [x, y] = coords;
    return x >= -180 && x <= 180 && y >= -90 && y <= 90;
  }

  protected zoom(action: number): void {
    if (this.map) {
      const view = this.map.getView();
      const currentZoom = view.getZoom() || 0;

      if (action == 0) {
        view.setZoom(currentZoom - 1); // Decrease zoom level by 1
      } else {
        view.setZoom(currentZoom + 1); // Increase zoom level by 1
      }
    }
  }

  changeCursorToTarget() {
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'url("icon/target.svg"), auto');
  }

  resetCursor() {
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'auto');
  }

  showPopupControlPoint(openMode: PopupOpenMode) {
    this.popupControlPointOpenMode = openMode;

    // Change the icon for control point creation
    this.vectorLayerCreatePoint.setStyle(new Style({
      image: this.iconControlPointPosition,
    }));

    // Destroy the previous popup if it exists
    if (this._popupCreateRef) {
      this._popupCreateRef.destroy();
    }
    this._popupCreateRef = this.popupContainer.createComponent(ControlPointModaleComponent);

    this._popupCreateRef.instance.setSite(this.selectedSite!);
    this._popupCreateRef.instance.setLastNumber(this.getNextNumeroPoint());

    if (openMode === PopupOpenMode.CREATE) {
    } else if (openMode === PopupOpenMode.EDIT) {
      this._popupCreateRef.instance.setIsEdit(true);

      let coordsControlPointSelected = this.currentStateService.getCurrentControlPointPosition();
      let customCoordinate: CustomCoordinate | null = null;

      if (coordsControlPointSelected == null) {
        customCoordinate = {
          coordX: 0,
          coordY: 0,
        } as CustomCoordinate;
      } else {
        let epsg: ProjectionLike = this.createFullEpsgName();
        let coordtrans = transform(coordsControlPointSelected!, MapConstants.EPSG_WGS84, epsg);

        customCoordinate = {
          coordX: this.isDegre ? coordtrans[0].toFixed(4) : coordtrans[0].toFixed(0),
          coordY: this.isDegre ? coordtrans[1].toFixed(4) : coordtrans[1].toFixed(0),
        } as CustomCoordinate;

        this._popupCreateRef.instance.setPositionEpsgSite(customCoordinate);
      }
    }

    this.actionAfterClose();

    this.changeCursorToTarget();
  }
  private getNextNumeroPoint(): number {
    if (this.controlPoints.length === 0) {
      return 1;
    }
    return Math.max(...this.controlPoints.map(cp => cp.numeroPoint)) + 1;
  }

  async showModalPopupEvent(openMode: PopupOpenMode) {
    this.popupControlPointOpenMode = openMode;
    
    // Change the icon for event creation
    this.vectorLayerCreatePoint.setStyle(new Style({
      image: this.iconSourcePosition,
    }));
    
    if (this._popupCreateRef) {
      this._popupCreateRef.destroy();
    }
    this._popupCreateRef = this.popupContainer.createComponent(EventModalComponent);
    this._popupCreateRef.instance.setSite(this.selectedSite!);
    if (openMode === PopupOpenMode.CREATE) {
    } else if (openMode === PopupOpenMode.EDIT) {
      this._popupCreateRef.instance.setIsEdit(true);

      let coordsEventSelected = this.currentStateService.getCurrentEvent()?.positionCoordinates;
      let customCoordinate: CustomCoordinate | null = null;

      if (coordsEventSelected == null) {
        customCoordinate = {
          coordX: 0,
          coordY: 0,
        } as CustomCoordinate;
      } else {
        let coordtrans = await this.positionService.transformeCoordinates(coordsEventSelected.x, coordsEventSelected.y, this.selectedSite!.epsg!, this.isDegre);
        customCoordinate = {
          coordX: coordtrans.coordX,
          coordY: coordtrans.coordY,
        } as CustomCoordinate;

        this._popupCreateRef.instance.setPositionEpsgSite(customCoordinate);
      }
    }

    this.actionAfterClose()

    this.changeCursorToTarget();
  }

  private actionAfterClose(): void {
    if (this._popupCreateRef) {
      this._popupCreateRef.instance.close.pipe(takeUntil(this.unsubscribe$)).subscribe((closeMode: PopupCloseMode) => {
        if (closeMode === PopupCloseMode.CLOSE || closeMode === PopupCloseMode.CREATED || closeMode === PopupCloseMode.EDITED) {
          this._popupCreateRef!.destroy();
          this._popupCreateRef = null;
          this.popupControlPointOpenMode = null;
          this.createPointLock = false;
          this.currentStateService.setClosePopup(closeMode);
          this.resetCursor();
          if (this.createPointFeature) {
            this.vectorSourceCreatePoint.removeFeature(this.createPointFeature);
          }

          if (closeMode === PopupCloseMode.EDITED) {
            const previousFeature = this.mapUtilsService.findFeatureById(this.vectorSourceBasePoint, this.currentStateService.getCurrentControlPoint()?.controlPointId!);
            if (previousFeature) {
              previousFeature.setStyle(this.mapUtilsService.createStyleWithCircle(this.iconControlPoint, previousFeature));
            }
          }
        } else if (closeMode === PopupCloseMode.CANCEL) {
          this.createPointLock = false;
          if (this.createPointFeature) {
            this.vectorSourceCreatePoint.removeFeature(this.createPointFeature);
            this.createPointFeature = null;
            this.changeCursorToTarget();
          }
        }
      });
    }
  }


  public setMouseCoordinates() {
    if (!this.selectedSite || !this.map) {
      return;
    }

    let coord = [0, 0];
    let epsg: ProjectionLike = this.createFullEpsgName();

    this.map.on('pointermove', evt => {
      coord = evt.coordinate;
      //we want the widget to display cordinates in its original form, therefore here we transform , once again
      coord = transform(coord, MapConstants.EPSG_REFERENCE_OL, epsg);
      this.isDegre = this.isLonLat(coord as [number, number]);
      this.mousePosition = {
        coordX: this.isDegre ? coord[0].toFixed(4) : coord[0].toFixed(0),
        coordY: this.isDegre ? coord[1].toFixed(4) : coord[1].toFixed(0),
      } as CustomCoordinate;

    });
  }

  private updateEventVisibilityOnMap(eventId: number, isHidden: boolean) {
    // Get the feature from our stored features
    const eventFeature = this.allEventFeatures[eventId];
    
    if (eventFeature) {
      if (isHidden) {
        // Remove the feature from the map if it's currently visible
        if (this.vectorSourceBaseEvent.hasFeature(eventFeature)) {
          this.vectorSourceBaseEvent.removeFeature(eventFeature);
        }
      } else {
        // Add the feature to the map if it's not already there
        if (!this.vectorSourceBaseEvent.hasFeature(eventFeature)) {
          this.vectorSourceBaseEvent.addFeature(eventFeature);
        }
      }
    } else {
      // If feature doesn't exist in our store (shouldn't happen), create it
      console.warn(`Event feature ${eventId} not found in stored features, creating new one`);
      const eventData = this.allEvents.find(event => event.id === eventId);
      if (eventData && eventData.positionCoordinates && !isHidden) {
        const coord = transform([eventData.positionCoordinates.x, eventData.positionCoordinates.y], MapConstants.EPSG_WGS84, MapConstants.EPSG_REFERENCE_OL);
        const feature = new Feature(new Point(coord));
        feature.set(MapConstants.FEATURE_NAME, FEATURE_TYPE.event);
        feature.set(MapConstants.FEATURE_LABEL, eventData.name);
        feature.set(MapConstants.FEATURE_ID, eventData.id);
        const featureStyle = this.mapUtilsService.createStyle(this.iconBlast, eventData.name);
        feature.setStyle(featureStyle);
        
        // Store and add the feature
        this.allEventFeatures[eventId] = feature;
        this.vectorSourceBaseEvent.addFeature(feature);
      }
    }
  }
}
